import { LinearProgress } from '@material-ui/core';
import OrderPage from '@pages/Order';
import PreOrderPage from '@pages/PreOrder';
import ErrorBoundary from '@settings/ErrorBoundary';
import ErrorController from '@settings/ErrorController';
import { SnackbarProvider } from 'notistack';
import React, { lazy, Suspense, useEffect } from 'react';

import Widget from '../../pages/MainWidget';
import TYOrder from '../../pages/TYOrder';
import useMyRouting from './useMyRouting';

export const pages = {
  widget: Widget,
  basket: lazy(() => import(/* webpackChunkName: "basket" */ '../../pages/Basket')),
  'success-order': TYOrder,
  'pre-order': PreOrderPage,
  order: OrderPage,
  favorites: lazy(() => import(/* webpackChunkName: "favorites" */ '../../pages/Favorites')),
  archives: lazy(() => import(/* webpackChunkName: "archives" */ '../../pages/Archives')),
};

export type Pages = keyof typeof pages;

const MyRouting = () => {
  const [page] = useMyRouting().usePage().useState();
  const { setPage } = useMyRouting().actions;
  const Page = pages[page];

  useEffect(() => {
    if (page === 'success-order') {
      setPage('basket');
    }
  }, []);

  useEffect(() => {
    const controllers = document.getElementById('dev-controllers');
    if (!controllers) {
      return;
    }
    if (page === 'pre-order' || page === 'order') {
      controllers.style.display = 'none';
    } else {
      controllers.style.display = 'flex';
    }
  }, [page]);

  return (
    <Suspense fallback={<LinearProgress sx={{ width: '100%' }} />}>
      <SnackbarProvider maxSnack={10} preventDuplicate={true} autoHideDuration={3000}>
        <ErrorBoundary needJSX={true}>
          <Page />
          <ErrorController />
        </ErrorBoundary>
      </SnackbarProvider>
    </Suspense>
  );
};

export default MyRouting;
